
export const settingsModules = [
  'profile',
  'permissions',
  'advanced'
]
